import React, { useState } from 'react';
import BtnSubmit from '../Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../Buttons/BtnWhiteBlackBorderBigSize';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';

const FileInputResult = (props) => {

  const downloadCSV = () => {
    const linesArray = props.invalidLineFile.map(item => item.line);
    const json = linesArray.map((line) => {
      const row = {};
      Object.keys(props.fileColName).forEach((key) => {
        const cellName = props.fileColName[key];
        const cellValue = line[key];
        row[cellName] = cellValue;
      });
      return row;
    });
    // Convert JSON to CSV
    const csv = Papa.unparse(json);
    const csvWithBOM = '\uFEFF' + csv;
    const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${props.fileName}.csv`);
  };



  const InvalidRows = props.invalidLineFile.map((response, rowIndex) => {
    const { line, invalidCells } = response;

    return (
      <div className='row_wrapper' key={rowIndex}>
        {Object.keys(line).map((key, cellIndex) => {
          const isInvalid = invalidCells[key];
          const cellName = props.fileColName[key];
          const cellValue = line[key];
          const cellErrorDesc = props.invalidCellReason[invalidCells[key]];

          return (
            <>
              {cellName && (
                <div className='row_cell' key={cellIndex}>
                  <div className='cell_key'>{cellName}</div>
                  <div key={key} className={`cell_value`}>
                    {cellValue}
                    <div className={`cell_invalid`}> {cellErrorDesc}</div>
                  </div>
                </div>
              )}
            </>
          );
        })}
      </div>
    );
  });

  return (
    <div className='invalidFileLineContainer'>
      <div className='title'>שורות שאינן תקינות</div>

      <div className='invalidRows'>{InvalidRows}</div>
      <div className='file-input-result-button'>
        <BtnSubmit onclick={() => props.uploadNewFile()} text={'לטעינת קובץ תקין'} />
      </div>
      {props.downloadCSV && (
        <div className='csv-download-button'>
          <BtnWhiteBlackBorderBigSize onclick={() => downloadCSV()} text={'להורידת קובץ CSV'} />
        </div>
      )}
    </div>
  );
};

export default FileInputResult;
